
export const labelledStockTopFields = [
  { name: "vendor",  label: "Vendor",  type: "dropdown", mandatory: true, visibility: true },
  { name: "branch",  label: "Branch",  type: "dropdown", mandatory: true, visibility: true },
  // ✅ NEW
  { name: "counter", label: "Counter", type: "dropdown", mandatory: true, visibility: true },
];



export const labelledStockFields = [
  {
    name: "category",
    label: "Category",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "product",
    label: "Product",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "design",
    label: "Design",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "purity",
    label: "Purity",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "totalWt",
    label: "Total Wt",
    type: "text",
    mandatory: true,
    visibility: true,
  },
  {
    name: "packingWt",
    label: "Packaging",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "grossWt",
    label: "Gross Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "stoneWt",
    label: "Stone Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "diamondWt",
    label: "Diamond Wt (ct)",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "netWt",
    label: "Net Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "pcs",
    label: "Pieces",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "stonePcs",
    label: "Stone Pcs",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "diamondPcs",
    label: "Diamond Pcs",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "totalStoneAmount",
    label: "Total Stn Amt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "totalDiamondAmount",
    label: "Total Dia Amt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "makingPercentage",
    label: "Making %",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "makingPerGram",
    label: "Making/Grm",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "fixedMaking",
    label: "Fixed Making",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "fixedAmount",
    label: "Fixed Amount",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "hallmarkCharge",
    label: "Hallmark Amt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "mrp",
    label: "MRP",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "sampleName",
    label: "Sample Name",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "huidCode",
    label: "HUID Code",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "description",
    label: "Description",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "stones",
    label: "Stones",
    type: "button",
    mandatory: false,
    visibility: true,
  },
   {
    name: "diamonds",
    label: "Diamonds",
    type: "button",
    mandatory: false,
    visibility: true,
  },
  {
    name: "images",
    label: "Pictures",
    type: "button",
    mandatory: false,
    visibility: true,
  },
];

export const purchaseStockTopFields = [
   {
    name: "invoiceNo",
    label: "Invoice Number",
    type: "text",
    mandatory: false,
    visibility: true,
  },
   {
    name: "purchasingDate",
    label: "Purchase Date",
    type: "date",
    mandatory: true,
    visibility: true,
  },
  {
    name: "vendor",
    label: "Vendor",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
   {
    name: "fineGold",
    label: "Fine Gold",
    type: "text",
    mandatory: false,
    visibility: false,
  },
   {
    name: "fineSilver",
    label: "Fine Silver",
    type: "text",
    mandatory: false,
    visibility: false,
  },
  {
    name: "advanceAmount",
    label: "Advance Amount",
    type: "text",
    mandatory: false,
    visibility: false,
  },
    {
    name: "balanceAmount",
    label: "Balance Amount",
    type: "text",
    mandatory: false,
    visibility: false,
  }
];
export const purchaseStockFields = [
  {
    name: "sku",
    label: "SKU",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
  {
    name: "category",
    label: "Category",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "product",
    label: "Product",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "design",
    label: "Design",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "purity",
    label: "Purity",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "totalWt",
    label: "Total Wt",
    type: "text",
    mandatory: true,
    visibility: true,
  },
  {
    name: "packingWt",
    label: "Packaging",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "grossWt",
    label: "Gross Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "stoneWt",
    label: "Stone Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "diamondWt",
    label: "Diamond Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "netWt",
    label: "Net Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "qty",
    label: "Qty",
    type: "text",
    mandatory: true,
    visibility: true,
  },
  {
    name: "pcs",
    label: "Pieces",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "stonePcs",
    label: "Stone Pcs",
    type: "text",
    mandatory: false,
    visibility: true,
  },
   
  {
    name: "diamondPcs",
    label: "Diamond Pcs",
    type: "text",
    mandatory: false,
    visibility: true,
  },
   {
    name: "ratePerGram",
    label: "Rate/Grm",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "finePercent",
    label: "Fine %",
    type: "text",
    mandatory: false,
    visibility: true,
  },
 
  {
    name: "makingPercentage",
    label: "Making %",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "makingPerGram",
    label: "Making/Grm",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "fixedMaking",
    label: "Fixed Making",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "fixedAmount",
    label: "Fixed Amount",
    type: "text",
    mandatory: false,
    visibility: true,
  },
   {
    name: "totalStoneAmount",
    label: "Total Stn Amt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "totalDiamondAmount",
    label: "Total Dia Amt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "hallmarkCharge",
    label: "Hallmark Amt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "totalItemMakingAmount",
    label: "Total Making",
    type: "text",
    mandatory: false,
    visibility: true,
  },
   {
    name: "totalItemAmount",
    label: "Total Item Amt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "itemFineWt",
    label: "Total Fine Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
   {
    name: "itemMakingWt",
    label: "Total Making Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
   {
    name: "itemFineMakingWt",
    label: "Total F+M Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  
  
 
  // {
  //   name: "sampleName",
  //   label: "Sample Name",
  //   type: "text",
  //   mandatory: false,
  //   visibility: true,
  // },
  // {
  //   name: "huidCode",
  //   label: "HUID Code",
  //   type: "text",
  //   mandatory: false,
  //   visibility: true,
  // },
  // {
  //   name: "description",
  //   label: "Description",
  //   type: "text",
  //   mandatory: false,
  //   visibility: true,
  // },
  {
    name: "stones",
    label: "Stones",
    type: "button",
    mandatory: false,
    visibility: true,
  },
   {
    name: "diamonds",
    label: "Diamonds",
    type: "button",
    mandatory: false,
    visibility: true,
  },
  {
    name: "images",
    label: "Pictures",
    type: "button",
    mandatory: false,
    visibility: true,
  },
];

export const unlabelledStockFields =[
  {
    name: "category",
    label: "Category",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "product",
    label: "Product",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "design",
    label: "Design",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "purity",
    label: "Purity",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "totalWt",
    label: "Total Wt",
    type: "text",
    mandatory: true,
    visibility: true,
  },
  {
    name: "packingWt",
    label: "Packaging",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "grossWt",
    label: "Gross Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "stoneWt",
    label: "Stone Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "diamondWt",
    label: "Diamond Wt (ct)",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "netWt",
    label: "Net Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "qty",
    label: "Quantity",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "finePercentage",
    label: "Fine %",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "wastagePercentage",
    label: "Wastage %",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "fineWastageWt",
    label: "F + W Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  }
 
];


export const InvoiceTopFields = [
  {
    name: "quotationNumber",
    label: "Quotation",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
  {
    name: "customer",
    label: "Customer",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
   
  {
    name: "branch",
    label: "Branch",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  
 
    {
    name: "invoiceNo",
    label: "Invoice No",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "invoiceDate",
    label: "Date",
    type: "date",
    mandatory: false,
    visibility: true,
  },
  {
    name: "urdNumber",
    label: "URD",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
 
 
  
];

// ⬇️ InvoiceTopFields ke paas hi add kar de

export const QuotationTopFields = [
  {
    name: "customer",
    label: "Customer",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "branch",
    label: "Branch",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
  {
    name: "quotationNo",
    label: "Quotation No",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "quotationDate",
    label: "Quotation Date",
    type: "date",
    mandatory: true,
    visibility: true,
  },
  // {
  //   name: "validTill",
  //   label: "Valid Till",
  //   type: "date",
  //   mandatory: false,
  //   visibility: true,
  // },
];


export const PakkaInvoiceFields = [
  {
    name: "itemCodeDetail",
    label: "Item Code",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
  // {name:"itemCode",label:"Item Code",type:"text",mandatory:false,visibility:true},
  {
    name: "category",
    label: "Category",
    type: "dropdown",
    mandatory: true,
    visibility: true,
    disabled: false,
  },
  {
    name: "product",
    label: "Product",
    type: "dropdown",
    mandatory: true,
    visibility: true,
    disabled: false,
  },
  {
    name: "design",
    label: "Design",
    type: "dropdown",
    mandatory: true,
    visibility: true,
    disabled: false,
  },
  {
    name: "purity",
    label: "Purity",
    type: "dropdown",
    mandatory: true,
    visibility: true,
    disabled: false,
  },
   {
    name: "counterRow",
    label: "Counter",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
  {
    name: "totalWt",
    label: "Total Wt",
    type: "text",
    mandatory: true,
    visibility: true,
  },
  {
    name: "packingWt",
    label: "Packaging",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "grossWt",
    label: "Gross Wt",
    type: "text",
    mandatory: true,
    visibility: true,
  },
  {
    name: "stoneWt",
    label: "Stone Wt (gm)",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "diamondWt",
    label: "Dia Wt (ct)",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "netWt",
    label: "Net Wt",
    type: "text",
    mandatory: true,
    visibility: true,
    // disabled: true,
  },
  {
    name: "qty",
    label: "Quantity",
    type: "text",
    mandatory: true,
    visibility: true,
  },

  {
    name: "pieces",
    label: "Pieces",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "stonePcs",
    label: "Stone Pcs",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "diamondPcs",
    label: "Diamond Pcs",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "ratePerGram",
    label: "Rate/Gm",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  // {
  //   name: "finePercentage",
  //   label: "Fine %",
  //   type: "text",
  //   mandatory: false,
  //   visibility: true,
  // },
  {
    name: "makingPercentage",
    label: "Making %",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "makingPerGram",
    label: "Making/Gm",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "fixedWastage",
    label: "Fixed Wastage",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "fixedAmount",
    label: "Fixed Amount",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "stoneAmount",
    label: "Stn Amount",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "diamondAmount",
    label: "Dia Amount",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "hallmarkAmount",
    label: "Hallmark",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "itemAmount",
    label: "Item Amount",
    type: "text",
    mandatory: false,
    visibility: false,
    disabled:true
  },
  // 
   
  {
    name: "itemGstAmount",
    label: "Tax",
    type: "text",
    mandatory: false,
    visibility: false,
    disabled:true
  },

  {
    name: "totalItemAmount",
    label: "Final Amount",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  //  {
  //   name: "fineWt",
  //   label: "Fine Wt",
  //   type: "text",
  //   mandatory: false,
  //   visibility: true,
  // },
  //  {
  //   name: "wastageWt",
  //   label: "Wastage Wt",
  //   type: "text",
  //   mandatory: false,
  //   visibility: true,
  // },
  //   {
  //   name: "fineWastageWt",
  //   label: "F+W Wt",
  //   type: "text",
  //   mandatory: false,
  //   visibility: true,
  // },
   {
    name: "stones",
    label: "Stones",
    type: "button",
    mandatory: false,
    visibility: true,
  },
  {
    name: "diamonds",
    label: "Diamonds",
    type: "button",
    mandatory: false,
    visibility: true,
  },
  //   {
  //   name: "huidCode",
  //   label: "HUID Code",
  //   type: "text",
  //   mandatory: false,
  //   visibility: true,
  // },
  {
    name: "mrp",
    label: "MRP",
    type: "text",
    mandatory: false,
    visibility: true,
  },
    {
    name: "soldBy",
    label: "Sold By",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
  {
    name: "commissionPercent",
    label: "Comm %",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "commissionAmount",
    label: "Comm Amt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
];


export const URDPakkaFields = [
 
  {
    name: "category",
    label: "Category",
    type: "dropdown",
    mandatory: true,
    visibility: true,
    disabled: false,
  },
  {
    name: "product",
    label: "Product",
    type: "dropdown",
    mandatory: true,
    visibility: true,
    disabled: false,
  },
  // {
  //   name: "qty",
  //   label: "Quantity",
  //   type: "text",
  //   mandatory: true,
  //   visibility: true,
  // },
  {
    name: "totalWt",
    label: "Total Wt",
    type: "text",
    mandatory: true,
    visibility: true,
  },
  {
    name: "packingWt",
    label: "Packaging",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "grossWt",
    label: "Gross Wt",
    type: "text",
    mandatory: true,
    visibility: true,
  },
  {
    name: "stoneWt",
    label: "Stone Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "diamondWt",
    label: "Dia Wt (CT)",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "netWt",
    label: "Net Wt",
    type: "text",
    mandatory: true,
    visibility: true,
    // disabled: true,
  },
 


 
 
  {
    name: "finePercentage",
    label: "Fine %",
    type: "text",
    mandatory: false,
    visibility: true,
  },


  
 
   {
    name: "fineWt",
    label: "Fine Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
   {
    name: "ratePerGram",
    label: "Rate/Gm",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "amount",
    label: "Amount",
    type: "text",
    mandatory: false,
    visibility: true,
  },

  {
    name: "urdDescription",
    label: "Description",
    type: "text",
    mandatory: false,
    visibility: true,
  },

  
 

];

export const looseStoneFields  = [
  {
    name: "stoneName",
    label: "Stone Name",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
    {
    name: "shapeName",
    label: "Stone Shape",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
   {
    name: "colorName",
    label: "Stone Color",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
   {
    name: "sizeName",
    label: "Stone Size",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
  {
    name: "settingTypeName",
    label: "Stone Setting Type",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
   {
    name: "stnWt",
    label: "Stone Wt",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  {
    name: "stnUnit",
    label: "Stone Unit",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
   {
    name: "stnDescription",
    label: "Description",
    type: "text",
    mandatory: false,
    visibility: true,
  },
   {
    name: "stnPcs",
    label: "Stone Pcs",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  
];
export const looseDiamondFields  = [
  {
    name: "diamondName",
    label: "Diamond Name",
    type: "dropdown",
    mandatory: true,
    visibility: true,
  },
    {
    name: "diamondShape",
    label: "Shape",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
   {
    name: "diamondClarity",
    label: "Clarity",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
   {
    name: "diamondColor",
    label: "Color",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
  {
    name: "diamondSieve",
    label: "Sieve",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
   {
    name: "diamondSize",
    label: "Size",
    type: "dropdown",
    mandatory: false,
    visibility: true,
  },
  {
    name: "diamondWt",
    label: "Weight (ct)",
    type: "text",
    mandatory: true,
    visibility: true,
  },
   {
    name: "diamondPcs",
    label: "Pieces",
    type: "text",
    mandatory: false,
    visibility: true,
  },
   {
    name: "diamondDescription",
    label: "Description",
    type: "text",
    mandatory: false,
    visibility: true,
  },
  
];
export const defaultStoneFields = { stnPopupName: "",stnPopupWt:"",stnPopupRateByWt:'', stnPopupPcs: "",stnPopupRateByPcs:"", stnPopupAmt: "",stnPopupDeduct:"deduct",stnPopupDescription:"" }
export const defaultDiamondFields = { diaPopupName: "",diaPopupShape:"",diaPopupColor:"",diaPopupClarity:"",diaPopupSieve:"",diaPopupSize:"",diaPopupWt:"",diaPopupRateByWt:'', diaPopupPcs: "",diaPopupRateByPcs:"", diaPopupAmt: "",diaPopupDeduct:"deduct",diaPopupDescription:"" }

export const  DECIMAL_RE = /^\d*\.?\d*$/;

export const handleDecimalPaste = (e) => {
  const text = e.clipboardData.getData("text");
  if (!DECIMAL_RE.test(text)) e.preventDefault();
};
export const handleDecimalKeyDown = (e, current = "") => {
  const nav = ["Backspace","Delete","ArrowLeft","ArrowRight","Home","End","Tab"];
  const ctrl = e.ctrlKey || e.metaKey;

  // allow nav keys + common shortcuts
  if (nav.includes(e.key) || (ctrl && ["a","c","v","x"].includes(e.key.toLowerCase()))) return;

  // allow single dot
  if (e.key === ".") {
    if (current.includes(".")) e.preventDefault();
    return;
  }

  // allow only digits
  if (!/^\d$/.test(e.key)) e.preventDefault();
};


export const handleIntegerPaste = (e) => {
  const text = e.clipboardData.getData("text");
  if (!INT_RE.test(text)) e.preventDefault();
};

export const handleIntegerBeforeInput = (e) => {
  // next value after this input
  const el = e.target;
  const next =
    el.value.slice(0, el.selectionStart) +
    (e.data ?? "") +
    el.value.slice(el.selectionEnd);
  if (!INT_RE.test(next)) e.preventDefault();
};

export const INT_RE = /^\d*$/;

export const handleIntegerKeyDown = (e) => {
  if (e.isComposing) return; // IME
  const nav = ["Backspace","Delete","ArrowLeft","ArrowRight","Home","End","Tab"];
  const ctrl = e.ctrlKey || e.metaKey;

  if (nav.includes(e.key) || (ctrl && ["a","c","v","x"].includes(e.key.toLowerCase()))) return;

  // block dots / numpad decimal explicitly
  if (e.key === "." || e.code === "NumpadDecimal" || e.key === "Decimal") {
    e.preventDefault();
    return;
  }

  // allow only 0-9
  if (!/^\d$/.test(e.key)) e.preventDefault();
};
